export interface QualityLevelInfo {
	index: number;
	height?: number;
	bitrate?: number;
	name?: string;
}

export interface QualityState {
	available: boolean;
	isNative: boolean;
	auto: boolean;
	currentLevel: number; // -1 for auto
	levels: QualityLevelInfo[];
}

export const defaultQualityState: QualityState = {
	available: false,
	isNative: false,
	auto: true,
	currentLevel: -1,
	levels: [],
};
